module Meevo.Components.Interceptors {

    export class ExceptionInterceptor {
        private notificationMode: Meevo.Model.NotificationModeType;
        private selfPaymentEntityVersionValidationExceptionKey = "SelfPaymentEntityVersionValidationException";
        private selfPaymentEntityVersionRetainCareCreditValidationExceptionKey = "SelfPaymentEntityVersionRetainCareCreditValidationException";
		private bookingOnGoogleSaleItemValidationExceptionKey = 'BookingOnGoogleSaleItemValidationException';
        duplicateAppointmentRequestValidationExceptionKey = 'DuplicateAppointmentRequestValidationException';

        constructor(private $injector: any,
            private $q: angular.IQService,
            private $rootScope: angular.IRootScopeService,
            private $window: angular.IWindowService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private busyService: Meevo.Components.Busy.IBusyService) {

            this.notificationMode = Meevo.Model.NotificationModeType.Modal;
        }

        request = (request: any): angular.IPromise<any> => {
            return request;
        };

        response = (response: any): angular.IPromise<any> => {
            return response;
        };

        requestError = (request: any): angular.IPromise<any> => {
            return request;
        };

        responseError = (response: any): angular.IPromise<any> => {

            this.busyService.stop();

            // ADO #122500 — AB Refresh print path sets this flag to suppress legacy ALERT!
            // dialogs for the entire print call chain (api/Settings/General + api/Report/AQ022).
            // The WC surfaces errors via Prism toast (printFailed @Input) instead.
            if ((this.$window as any).__abRefreshPrintActive === true) {
                return this.$q.reject(response);
            }
            const validationExceptionKey = 'ValidationException';
            const appointmentServiceValidationExceptionKey = 'AppointmentServiceValidationException';
            const customMessageWrappedException = 'CustomMessageWrappedException';
            const sqlExceptionKey = 'SqlException';
            const clientDeleteValidationExceptionKey = 'ClientDeleteValidationException';
            const clientPurgeValidationExceptionKey = 'ClientPurgeValidationException';
            const deviceActivationExceptionKey = 'DeviceActivationException';
            const identityCurrent = this.identityService && this.identityService.current();
            const tenantId = identityCurrent && this.identityService.current().tenantId;
            const params = response.config && response.config.params;
            const url = response.config && response.config.url;
            const sqlErrorMessage = 'Procedure';

            var message = response.data && response.data.responseStatus && response.data.responseStatus.message;

            /*
            //-1 Denotes server unavailable/offline/aborted/timed out request
            if (response.status === -1) {
                return this.unauthorizedAccessHandler(response);
            } else
            */

            // skip assets (prevent infinite loop when error msg itself has missing image)
            if (url && url.indexOf('/assets/') !== -1) {
                return;
            }

            if (response.data && response.data.errorCode) {
                if (response.data.skipInterceptor === true) {
                    return this.$q.reject(response);
                }
                response.data.responseStatus = response.data;
            }

            if (response.data &&
                response.data.responseStatus &&
                response.data.responseStatus.errorCode === validationExceptionKey &&
                response.data.responseStatus.meta &&
                response.data.responseStatus.meta.skipInterceptor === true) {
                return this.$q.reject(response);
            }

            // statusText is not returned in NET5, cause unknown yet
            // set it from errorCode but code should check primarily by status code
            const errorCode = response.data && response.data.responseStatus && response.data.responseStatus.errorCode;
            response.statusText = response.statusText || errorCode;

            // Using template call to determine if feature is enabled.  We don't want an alert to be displayed if
            // that's the case.
            if (url && url.toLowerCase().indexOf("paymentplan/template") !== -1 && params && params.ignoreException) {
                return this.$q.reject(response);
            }

            // don't show a message for tokenMigration download link
            if (url && url.toLowerCase().indexOf("tokenmigration/mappingfile") !== -1 && response.status !== 200) {
                return this.$q.reject(response);
            }

            if (response.statusText === 'InlineValidationException' ||
                response.statusText === this.duplicateAppointmentRequestValidationExceptionKey ||
                (params && params.skipInterceptor === true)
                || errorCode === "InlineValidationException") {
                return this.$q.reject(response);
            }

            if (tenantId && url === `/api/auth/credentials?tenantId=${tenantId}`) {
                return this.$q.reject(response);
            }

            if (response.statusText === this.selfPaymentEntityVersionValidationExceptionKey ||
                response.statusText === this.selfPaymentEntityVersionRetainCareCreditValidationExceptionKey) {
                return this.selfPaymentEntityVersionValidationExceptionHandler(response);
            }

            if (response.statusText == clientDeleteValidationExceptionKey || response.statusText == clientPurgeValidationExceptionKey ) {
                return this.clientValidationExceptionHandler(response);
            }
            if (response.status === 412 ||
                response.statusText === validationExceptionKey ||
                response.statusText === appointmentServiceValidationExceptionKey ||
                errorCode && (
                    errorCode === validationExceptionKey ||
                    errorCode === appointmentServiceValidationExceptionKey ||
                    errorCode === this.bookingOnGoogleSaleItemValidationExceptionKey ||
                    errorCode.startsWith(customMessageWrappedException))) {
                return this.validationExceptionHandler(response);
            }

            if (response.statusText === sqlExceptionKey || errorCode === sqlExceptionKey || (message && message.includes(sqlErrorMessage) === true)) {
                return this.sqlExceptionHandler(response);
            }

            if (response.statusText === deviceActivationExceptionKey || errorCode === deviceActivationExceptionKey) {
                return this.deviceActivationExceptionHandler(response);
            }

            if (response.status === 401 || (response.status === 400 && response.statusText === "INVALIDTENANTREQUEST")) {
                return this.unauthorizedAccessHandler(response);
            }

            if (response.status === 403) {
                return this.forbiddenAccessHandler(response);
            }

            if (response.status === 503) {
                return this.serviceUnavailableHandler(response);
            }

            if (response.status !== 409 && response.status !== 410 && response.status !== 300) {
                if (!(response.config && response.config.timeout)) {
                    return this.unknownError(response);
                }
            }

            return response;
        };

        /**
         * Process Unknown Error
         * @param response
         */
        private unknownError(response: any): angular.IPromise<any> {
            if (response.config.url.endsWith("styles/meevo.json") && response.status == 404) {
                return this.$q.reject(response)
            }

            response.isUnknownError = true;

            const params = response.config && response.config.params;
            if (params && params.skipUnknownError === true) {
                return this.$q.reject(response);
            }

            let translate = this.$injector.get('$translate');

            let errorCode = response.data && response.data.responseStatus && response.data.responseStatus.errorCode
                ? `(${response.data.responseStatus.errorCode}) `
                : "";

            let errorMessage = translate.instant("ERROR_HTTP_UNKNOWN");
            if (Model.Guard.isNothing(errorCode)) {
                console.error("UnknownError Without Error Code: " + response);
            }
            console.error(errorCode + errorMessage, response);

            this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION, errorCode + errorMessage, this.notificationMode, true);

            return this.$q.reject(response);
        }

        /**
         * Process Unauthorized Access Messages
         * @param response
         */
        private unauthorizedAccessHandler(response: any): angular.IPromise<any> {
            this.identityService.clearToken();
            if ($('#userLockout').length > 0) {
                this.$window.stop();
                return this.$q.reject(response);
            }


            var tenantId = this.$window.location.search.split('tenantId=')[1];

            if (this.identityService.current() && this.identityService.current().sessionTimeoutRedirectUrl && (tenantId.search("status") < 0)) {
                var urlLogin = this.identityService.current().sessionTimeoutRedirectUrl
                if (urlLogin == 'login') {
                    urlLogin = "login" + `/${tenantId}`;
                }
                this.$window.location.assign(urlLogin);

            } else if (tenantId.search("status") > 0) {
                tenantId = decodeURIComponent(tenantId);
                this.$window.stop();
                this.$window.location.assign(tenantId);
            }
            else {
                this.$window.onbeforeunload = () => null;
                this.$window.stop();
                this.$window.location.replace("login" + `/${tenantId}`);
                return ;
            }
            return this.$q.reject(response);
        }

        /**
         * Process Forbidden Access Messages
         * @param response
         */
        private forbiddenAccessHandler(response: any): angular.IPromise<any> {
            let translateService = this.$injector.get('$translate');
            let message;
            let subMessage = response.statusText;
            let keys: string[] = new Array();
            let keyPath: string;

            if (!_.isEmpty(response.data) && !_.isEmpty(response.data.responseStatus)) {
                if (!_.isEmpty(response.data.responseStatus.errorcode)) {
                    subMessage = response.data.responseStatus.errorcode;
                }
                if (!_.isEmpty(response.data.responseStatus.message)) {
                    keys = response.data.responseStatus.message.replace(/:/gi, '_').split(/\r?\n/);
                    keyPath = response.data.responseStatus.message.replace(/:/gi, '>');
                }
            }

            const responseStatus = response.data.responseStatus;
            message = translateService.instant(`ERROR_HTTP_403${responseStatus ? '_' + response.data.responseStatus.message : ''} `);
            if (subMessage == "CHECKACCESSFAILED") {
                message = translateService.instant('ERROR_HTTP_403');
                if (Model.Guard.isSomething(keyPath) && keyPath.includes('>')) {
                    keyPath = keyPath.split(' ')[0];
                    keyPath = keyPath.replaceAll(">", " > ");

                    message = message + "<BR>" + keyPath;
                }

            } else if (subMessage == 'CANELEVATE') {
                let deferred = this.$q.defer();
                this.$rootScope.$emit(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, deferred, keys, null, null, keyPath);
                var httpService = this.$injector.get('$http');
                return deferred.promise.then(() => {
                    return httpService(response.config);
                }, () => {
                    return this.$q.reject(response);
                });

            } else if (subMessage == 'CANNOTELEVATE') { /*  AuthService.cs returning Elevation Errors To Be Handle By ELEVATION_CHALLENGE Only  */
                return this.$q.reject(response);

            } else if (subMessage != "Forbidden") {
                message = subMessage + ':<br/>' + message;
            }

            this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION, message, this.notificationMode, true);

            return this.$q.reject(response);
        }

        private formatValidationError(responseStatus, translate): string {
            let message = null;
			const errorCode = responseStatus.errorCode;

            const appendErrors = responseStatus.meta && !!responseStatus.meta.AppendErrors;
			if (responseStatus.errors && responseStatus.errors.length > 0 && !appendErrors) {
                // filter out empty error messages
                responseStatus.errors = responseStatus.errors.filter(error => error.message);

				let messages = null;
				if (errorCode === this.bookingOnGoogleSaleItemValidationExceptionKey) {
					messages = [responseStatus.message ? `<p>${translate.instant(responseStatus.message)}</p> <ul style='margin:0'>` : "<ul style='margin:0'>"];
					for (let error of responseStatus.errors) {
                        messages.push("<li>", translate.instant(error.message, error.customState), "</li>");
                    }
                    messages.push('</ul>');
					return messages.join('');
				}

                if (responseStatus.errors.length === 1) {
                    let error = responseStatus.errors[0];
                    if (error.customState) {
                        for (let prop in error.customState) {
                            if (prop.toLowerCase().startsWith("customerrormessage") && error.customState.hasOwnProperty(prop))
                            {
                                error.customState[prop] = translate.instant(error.customState[prop]);
                            }
                        }
                    }
                    message = translate.instant(error.message, error.customState);
                } else {
                    let messages = ['<ul style="margin:0">'];
                    for (let error of responseStatus.errors) {
                        messages.push("<li>", translate.instant(error.message, error.customState), "</li>");
                    }
                    messages.push('</ul>');
                    message = messages.join('');
                }
            }
            else if (responseStatus.message) {
                message = translate.instant(responseStatus.message);
                
                if (appendErrors) {
                    for (let error of (responseStatus.errors || []))
                    {
                        message += ` ${translate.instant(error.message)}`;
                    }
                }
            }

            return message;
        }

        private selfPaymentEntityVersionValidationExceptionHandler(response: any): angular.IPromise<any> {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.NO_SALE_SELF_PAYMENT_ENTITY_VERSION_VALIDATION_FAILURE, {
                retainCareCredit: response.statusText === this.selfPaymentEntityVersionRetainCareCreditValidationExceptionKey
            });
            return this.$q.reject(response);
        }
        /**
         * Process exceptions occuring due to validation errors.
         * @param response
         */
        private validationExceptionHandler(response: any): angular.IPromise<any> {
            const translate = this.$injector.get('$translate');
            let message = `ERROR_HTTP_${response.status}_`;

            if (response.data && response.data.responseStatus) {
                message = this.formatValidationError(response.data.responseStatus, translate);
            }

            if (response.data && response.data.responseStatus && response.data.responseStatus.message.includes('RDSSERVER')) {
                message = translate.instant(`ERROR_HTTP_${response.status}_${response.data.responseStatus.message}`);
                this.$rootScope.$emit(Meevo.Components.Common.Messages.RDS_RESPONSE, message, response);
            } else {
                var promptAsError = false;
                promptAsError = response.config.method == "PUT" && response.config.url == "/api/employee/" && message.endsWith("has reached its max user count.");
                this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION, message, this.notificationMode, false, promptAsError);
            }

            return this.$q.reject(response);
        }

        /**
         * Process exceptions occuring due to sql errors.
         * @param response
         */
        private sqlExceptionHandler(response: any): angular.IPromise<any> {
            // SELECT * FROM [master].[dbo].sysMessages => Query DB to handle specific error numbers
            // [Error Number]: 2601 =>  Cannot insert duplicate key row in object '%.*ls' with unique index '%.*ls'. The duplicate key value is %ls.
            // [Error Number]: 60000 => Current entity version does not match the passed in entity version.

            let sqlError = 'ERROR_SQL';
            let serviceSplitSqlError = "Invalid pre-split detected!";
            let allMessage = "";
            let translationRequired = true;
            let translate = this.$injector.get('$translate');
            if (!_.isEmpty(response.data) && !_.isEmpty(response.data.responseStatus) && !_.isEmpty(response.data.responseStatus.message)) {
                let exception = response.data.responseStatus.message || '';
                var errorNumbers = exception.match(/\[Error Number\]:+\s\d+/g).filter((v, i, a) => a.indexOf(v) === i);//list of unique sqlErrors
                errorNumbers.some((sqlErrorNumber) => {
                    let message = sqlError;
                    let sqlErrorCode: any = (/'(U[QC]?IX_.+(_.+)?_.+)'/).exec(exception);    //  QIX_Employee_L_EmployeeCode||UCIX_vUser_Chk_DisplayName||UIX_User_T_USERNAME || UIX_Location_StoreName
                    sqlErrorCode = sqlErrorCode && sqlErrorCode[1] ? sqlErrorCode[1].replace(/\s/g, '') : sqlErrorCode;
                    sqlErrorNumber = sqlErrorNumber.replaceAll(/\s/g, '')

                    //Split Service Pre(51002) & Post(51003) Merge check if they have Circular reference.
                    var splitErrorNumber = sqlErrorNumber != null ? sqlErrorNumber.split(":") : "";
                    var errorNum = splitErrorNumber.length == 2 ? splitErrorNumber[1].trim() : "";
                    if (errorNum == "51003" || errorNum == "51002" || (errorNum == "530" && exception.includes('[srvc].[usp_ServiceSplit_BlacklistedChildService_Tenant_Get]'))) {
                        allMessage = 'At least two of the split services are in conflict with each other when splitting.';
                        return true;  //override other messages with this excplicit split error message
                    }

                    message += sqlErrorNumber ? `_${sqlErrorNumber}` : '';
                    message += sqlErrorCode ? `_${sqlErrorCode}` : '';
                    message = translate.instant(message) === message ? sqlError : message;

                    allMessage += message === sqlError ? `(${response.data.responseStatus.errorCode}) ${translate.instant(message)}` : message;
                })
            }

            this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION, allMessage, this.notificationMode, translationRequired);

            return this.$q.reject(response);
        }

        /**
         * Process exceptions occuring due to response.status === 503
         * @param response
         */
        private serviceUnavailableHandler(response: any): angular.IPromise<any> {
            let translate = this.$injector.get('$translate');
            var error = Meevo.Components.Common.Messages.SERVER_VALIDATION;
            var message = `ERROR_HTTP_${response.status}_`;

            if (response.data && response.data.responseStatus && response.data.responseStatus.message.includes('RDSSERVER')) {
                error = Meevo.Components.Common.Messages.RDS_RESPONSE
                message += response.data.responseStatus.message;
            }

            this.$rootScope.$emit(error, translate.instant(message), response);
            return this.$q.reject(response);
        }

        /**
         * Process exceptions occuring due to validation errors.
         * @param response
         */
        private deviceActivationExceptionHandler(response: any): angular.IPromise<any> {
            let translateService = this.$injector.get('$translate');
            let messageHeading = translateService.instant('LABEL_DEVICE_ACTIVATION_FAILED_MESSAGE');
            let processorDetailsHeading = translateService.instant('LABEL_PROCESSOR_DETAILS');
            // Build translated heading
            let message = messageHeading + '<br/><b>' + processorDetailsHeading + ':</b> '
            // Build message detail
            if (!_.isEmpty(response.data)
                && !_.isEmpty(response.data.responseStatus)
                && !_.isEmpty(response.data.responseStatus.message)) {
                // errors is optional on responseStatus and is absent when the processor sent no
                // field-level reasons - without the guard this throws and no alert is shown at all
                if (response.data.responseStatus.errors && response.data.responseStatus.errors.length) {
                    let messageDetails = '';
                    for (var i = 0; i < response.data.responseStatus.errors.length; i++) {
                        messageDetails += (i > 0 ? "<br/>" : "") + response.data.responseStatus.errors[i].message;
                    }
                    message += '<br/>' + messageDetails;
                }
                else {
                    message += response.data.responseStatus.message;
                }
            } else {
                message = translateService.instant("LABEL_DEVICE_ACTIVATION_ERROR");
            }

            this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION, message, this.notificationMode);

            return this.$q.reject(response);
        }

        /**
        * Process exceptions occuring due to validation errors.
        * @param response
        */
        private clientValidationExceptionHandler(response: any): angular.IPromise<any> {
            let translateService = this.$injector.get('$translate');
            // Build translated heading
            let message = translateService.instant(response.data.responseStatus.message);
            // Build message detail
            if (!_.isEmpty(response.data)
                && !_.isEmpty(response.data.responseStatus)
                && !_.isEmpty(response.data.responseStatus.message)) {
                if (response.data.responseStatus.errors.length) {
                    let messageDetails = '<ul style="margin:0">';
                    for (var i = 0; i < response.data.responseStatus.errors.length; i++) {
                        messageDetails += (i == 0 ? "" : "") + "<li>" + response.data.responseStatus.errors[i].message + "</li>";
                    }
                    messageDetails += '</ul>';
                    message += messageDetails;
                    if (response.data.responseStatus.meta) {
                        if (response.data.responseStatus.meta.PostMessage) {
                            message += translateService.instant(response.data.responseStatus.meta.PostMessage);
                        }
                    }
                }
                else {
                    message += response.data.responseStatus.message;
                }
            } else {
                if (response.data.responseStatus.message.includes('ClientUpdateNotifyException')) {
                    message = "The client is currently receiving notifications";
                }
            }
            this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION, message, this.notificationMode);
            return this.$q.reject(response);
        }
        /**
         * Process exceptions occuring due to validation errors.
         * @param response
        */

        static factory(): Function {
            let svc = ($injector: any,
                $q: angular.IQService, $rootScope: angular.IRootScopeService, $window: angular.IWindowService,
                identityService: Meevo.Components.Common.IIdentityService,
                busyService: Meevo.Components.Busy.IBusyService) => {
                return new ExceptionInterceptor($injector, $q, $rootScope, $window, identityService, busyService);
            }

            svc.$inject = ["$injector", "$q", "$rootScope", "$window", "meevo.components.common.IdentityService", "meevo.components.busy.BusyService"];
            return svc;
        };
    }

    angular.module("meevo.components.interceptors")
        .factory("meevo.components.interceptors.ExceptionInterceptor", ExceptionInterceptor.factory());

    const gridsterPlacementError: string = 'Unable to place item!';

    angular.module("meevo").config(['$provide', $provide => {
        $provide.decorator("$exceptionHandler", ['$delegate', $delegate => (exception, cause) => {
            $delegate(exception, cause);

            if (exception.message === gridsterPlacementError) {
                onUnableToPlaceItemException();
            }

        }]);

        function onUnableToPlaceItemException() {
            // TODO: Review a non-global-window way to approach. We have to do this way
            // since we're in a config block currently.
            if ((<any>window).gridsterPlacementError) {
                (<any>window).gridsterPlacementError();
            }
        }
    }]);
}
